import { getView, rejectAuth } from '@/lib/utils';


export default {
  path: '/login',
  name: 'login',
  component: getView('pages/PageLogin'),
  beforeEnter: rejectAuth,
  meta: {
    crumbs: 'Login',
  },
};
